import * as types from "../actions/actionType";
import * as _ from "lodash";


const calculateTotalAmountDue = (accounts = []) => {
	return accounts.reduce((sum, acc) => {
		const n = Number(acc && acc.minimum_due_amount);
		return sum + (Number.isFinite(n) ? n : 0);
	}, 0);
};

const accountReducer = (state, action) => { 
	if(state===null || state===undefined){
		state={};
	}
	switch (action.type) {
		case types.LOAD_ACCOUNTS_SUCCESS:
			return {
				...state,
				accountMatchBool: action.accounts.input_account_match,
				customerCount: action.accounts.customer_count,
				accounts: _.keyBy(action.accounts.accounts, "account_number"),
				currentAccount: action.accounts.accounts[0].account_number,
				total_amount_due: calculateTotalAmountDue(action.accounts.accounts),
				error: false,
				errorMessage: "",
				token: action.accounts.access_token,
				pcgx:action.pcgx
			};
		case types.LOAD_ACCOUNTS_FAILED:
			return {
				...state,
				error: true,
				errorInfo: action.errorInfo
			};
		case types.IS_IE:
			return {
				...state,
				isIEFlag:action.isIEFlag
			};
		case types.SET_CURRENT_ACCOUNT:
			return {
				...state,
				currentAccount: action.accountNumber
			};
		case types.SET_CURRENT_POLICY:
			return {
				...state,
				currentPolicy: action.policyNumber
			};
		case types.UPDATE_CURRENT_ACCOUNT:
    let total = 0;

    _.forOwn(action.accountUpdate, accountData => {
        const billingPaymentOption = accountData.paymentOption;

        // Only process policy-level amounts for non-CIP accounts that have policies
        if (accountData.policies && accountData.policies.length > 0 && accountData.source_type !== 'CIP') {
            let policy_total = 0;

            // Check if any policies have their own payment options
            //let hasAnyPolicyLevelOption = _.some(accountData.policies, p => p.paymentOption);

            _.forEach(accountData.policies, policy => {
                let policyAmount = 0;

                if (billingPaymentOption) {
                    // Billing-level selection overrides all policies
                    policy.paymentOption = billingPaymentOption;
                    if (billingPaymentOption === 'min') {
                        policyAmount = parseFloat(policy.min_due || 0);
                    } else if (billingPaymentOption === 'Full payment') {
                        policyAmount = parseFloat(policy.total_due || 0);
                    } else if (billingPaymentOption === 'No payment') {
                        policyAmount = 0;
                    }
                } else if (policy.paymentOption) {
                    // Policy has its own selection
                    if (policy.paymentOption === 'Other amount' && policy.policy_amount > 0) {
                        policyAmount = parseFloat(policy.policy_amount);
                    } else if (policy.paymentOption === 'min') {
                        policyAmount = parseFloat(policy.min_due || 0);
                    } else if (policy.paymentOption === 'Full payment') {
                        policyAmount = parseFloat(policy.total_due || 0);
                    } else if (policy.paymentOption === 'No payment') {
                        policyAmount = 0;
                    }
                } else {
                    // Default: use min_due
                    policyAmount = parseFloat(policy.min_due || 0);
                }

                policy.policy_amount = policyAmount;
                policy.summaryPolicyData = policyAmount;
                policy_total += policyAmount;
            });

            // Only set payment_amount from policy total if no billing-level option chosen
            if (!billingPaymentOption) {
                accountData.payment_amount = policy_total;
            }

        } else {
            // No policies (or CIP): billing-level payment_amount is already set correctly
            // by PayOptions — do NOT overwrite it here
            if (billingPaymentOption === 'No payment') {
                accountData.payment_amount = 0;
            } else if (billingPaymentOption === 'min') {
                accountData.payment_amount = parseFloat(accountData.minimum_due_amount || 0);
            } else if (billingPaymentOption === 'Full payment') {
                accountData.payment_amount = parseFloat(accountData.pay_in_full_amount || 0);
            } else if (!billingPaymentOption) {
                // Untouched account — keep minimum_due_amount as default
                accountData.payment_amount = parseFloat(accountData.minimum_due_amount || 0);
            }
        }

        // Add to grand total
        if (accountData.payment_amount >= 0) {
            total += parseFloat(accountData.payment_amount);
        }
    });

    return {
        ...state,
        accounts: action.accountUpdate,
        total_amount_due: total
    };
		
	default:
			return state;
	}
}

export default accountReducer;



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js